import { Header } from "components/Header";
import { OFIconButton } from "design_system/components/IconButton";
import { ArrowLeftIcon } from "design_system/icons";

type Props = {
  onClickBack?: () => void;
  hideHeaderLeft?: boolean;
  customLogoClick?: () => void;
  isClickable?: boolean;
  redirectToWebFlowWhenNotAuth?: boolean;
};

export const NavigationBar = ({
  onClickBack,
  hideHeaderLeft,
  isClickable,
  customLogoClick,
  redirectToWebFlowWhenNotAuth
}: Props) => {
  return (
    <Header
      isClickable={isClickable}
      customLogoClick={customLogoClick}
      redirectToWebFlowWhenNotAuth={redirectToWebFlowWhenNotAuth}
    >
      {!hideHeaderLeft && (
        <Header.Left>
          <OFIconButton
            variant="roundedPrimary"
            icon={<ArrowLeftIcon size={32} />}
            onClick={onClickBack}
          />
        </Header.Left>
      )}
    </Header>
  );
};
